import ChatLoadingView from './ChatLoadingView';

export default ChatLoadingView;
